import styled from 'styled-components';


const Root = styled.div`
	position: relative;
	width: calc(100% + 30px);
	height: auto;
	display: flex;
	flex-flow: row wrap;
	align-items: flex-start;
	margin: 0 -15px;
	overflow: hidden;

	@media(max-width: 960px) {
		justify-content: center;
	}
`;

const CMSCard = styled.div`
	position: relative;
	margin: 20px 15px;
`;

const CMSCardHeader = styled.div`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	opacity: 0.6;
	margin-bottom: 15px;
`;

const CMSIconLayout = styled.div`
	margin-right: 15px;
`;

const CMSName = styled.div`
	font-size: 16px;
  font-weight: 500;
`;

const CMSControlsLayout = styled.div``;

const AddButtonLayout = styled.div`
	position: relative;
	left: -10px;
	margin-bottom: 4px;
`;

export {
	Root,
	CMSCard,
	CMSCardHeader,
	CMSIconLayout,
	CMSName,
	CMSControlsLayout,
	AddButtonLayout,
};
